module.exports = __webpack_public_path__ + "static/shopify_apple-pay-57229f025271ba9a482ad0016513efde.svg";